export default __webpack_public_path__ + "static/media/weibo.eef37428.jpg";